<template>
  <el-form class="template-box" :model="form" ref="ruleForm" label-width="180px">
    <el-col :span="8">
      <el-form-item :label="$t('lang.programName')" prop="templateName" required>
        <el-input v-model="form.templateName" auth-typecomplete="off" maxlength="128" />
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item :label="$t('lang.Episode')">
        <el-input v-model="form.episode" auth-typecomplete="off" maxlength="32" />
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item :label="$t('lang.HouseId')" prop="houseId">
        <el-input v-model="form.houseId" readonly auth-typecomplete="off" />
      </el-form-item>
    </el-col>
    <!-- 选择文件或者source -->
    <el-col :span="8">
      <el-form-item :label="$t('lang.referenceMedia')" class="referenceFile" prop="referenceMediaId">
        <!-- <public-file-select
          :SelectType="1"
          :SelectValue="{
            fileId: form.referenceMediaId,
            fileName: form.referenceMediaName,
          }"
          :AppendBody="false"
          @fileSelectChange="
            (pitchOnFile) => changeReferenceFile(pitchOnFile)
          "
        ></public-file-select> -->
        <div class="ReferenceMedia">
          <div class="MediaType">
            <el-select v-model="form.sourceType" @change="sourceTypeChange">
              <el-option v-for="(item, index) in ['Media', 'Live']" :key="index" :label="item" :value="index">
              </el-option>
            </el-select>
          </div>
          <div class="MediaSelect">
            <public-file-select v-if="!form.sourceType" :SelectType="1" :SelectValue="{
                  fileId: form.referenceMediaId,
                  fileName: form.referenceMediaName,
                }" :AppendBody="false" @fileSelectChange="
                  pitchOnFile => changeReferenceFile(pitchOnFile)
                "></public-file-select>
            <el-select v-if="form.sourceType" v-model="form.referenceMediaId" :popper-append-to-body="false" v-scroll="SourcebindScroll" filterable :filter-method="getSourceList" @change="SelectSource">
              <el-option v-for="item in SourceList" :key="item.peerId" :label="item.name" :value="item.peerId">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item :label="$t('lang.timingList')" class="timingFile" prop="timingId">
        <el-select v-model="form.timingId" @change="changeTimingFile" v-scroll="bindScroll" :popper-append-to-body="false" filterable :filter-method="searchFile">
          <el-option v-for="item in mcpTimingList" :key="item.id" :label="item.name" :value="item.id">
            <span class="timing-item ellipsis" :title="item.name">{{ item.name }}</span>
            <span class="deltete-icon" v-if="form.timingId != item.id" style="float: right;">
              <i class="el-icon-delete" @click.stop="deleteTiming(item)"></i>
            </span>
          </el-option>
        </el-select>
        <upload-file :info="TimingUpload"></upload-file>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item :label="$t('lang.DurationLabel')" required>
        <el-input v-model="programDuration" @change="DurationChange" auth-typecomplete="off" maxlength="32">
          <template slot="append">{{ $t('lang.min') }}</template>
        </el-input>
      </el-form-item>
    </el-col>
    <el-col :span="8">
      <el-form-item :label="$t('lang.ariDate')">
        <el-date-picker v-model="startTime" :default-value="nowDate" :picker-options="pickerDateBeg" value-format="timestamp" format="yyyy-MM-dd h:mm:ss A" @change="changeHouseId" type="datetime">
        </el-date-picker>
      </el-form-item>
    </el-col>
    <el-col :span="8" v-if="startTime != null && startTime != ''">
      <!-- <el-form-item label="Receiver:">
              <select-search-r
                  type="R"
                  :searchParam="rPar"
                  selRName=""
                  @currentSelectData="currentSelectData"
                  class="rSelect"
              />
          </el-form-item> -->
    </el-col>
    <el-col :span="24">
      <el-form-item :label="$t('lang.programDesc')">
        <el-input type="textarea" v-model="form.description" maxlength="1024" resize="none">
        </el-input>
      </el-form-item>
    </el-col>
    <el-divider class="line"></el-divider>
    <div class="calculate-info">
      <el-col :span="8">
        <el-form-item :label="$t('lang.TRT')">
          <span>{{ form.mediaTotalTime == 0? '00:00:00' : form.mediaTotalTime * 1000 | DURATION }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8" :class="{'redColor': form.overUnderTime != 0}">
        <el-form-item :label="$t('lang.overTime')">
          <span>{{ !overTimeFlag && form.overUnderTime != 0? '- ' : '' }}{{ form.overUnderTime == 0? '00:00:00' : form.overUnderTime * 1000 | DURATION }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="Black">
          <span>{{ form.blackTime == 0? '00:00:00' : form.blackTime * 1000 | DURATION }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.scteDuration')">
          <el-select v-model="form.scteSpliceDurationDefault" @change="changeTableData">
            <el-option v-for="item in scteDefaultList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.scteInsertion')">
          <span>{{ scteTimes }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item :label="$t('lang.totalTime')">
          <span>{{ form.scteTotalTime == 0? '00:00:00' : form.scteTotalTime * 1000 | DURATION }}</span>
        </el-form-item>
      </el-col>
    </div>
    <!-- 下面子事件 -->
    <el-table :data="tableData" v-loading="loading" class="event-table" element-loading-background="transparent">
      <el-table-column width="30px">
        <template slot-scope="scope">
          <span v-if="scope.row.segmentId == 1" style="margin: 0; ">{{ scope.row.SerialNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px">
        <template slot-scope="scope">
          <select-menu :data="config.segments" :rowKey="scope.$index" :selectVal="scope.row.segmentId" :noTranslate="true" :callback="changeSegment" :placeholder="$t('lang.placeSelect')"></select-menu>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Event')">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.segmentId == 1">Reference Media</span> -->
          <select-menu v-if="scope.row.segmentId == 2" :data="config.scteType" :rowKey="scope.$index" :selectVal="scope.row.eventOperationType" :noTranslate="true" :callback="changeScteEvent"></select-menu>
          <!-- <select-menu
                        v-if="scope.row.segmentId == 3"
                        :data="config.logoConfig"
                        :rowKey="scope.$index"
                        :selectVal="scope.row.eventOperationType"
                        :noTranslate="true"
                        :callback="changeScteEvent"
                    ></select-menu> -->
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.File')">
        <template slot-scope="scope">
          <span v-if="scope.row.segmentId == 1">{{ form.referenceMediaName }}</span>
          <public-file-select v-if="scope.row.segmentId == 2 && scope.row.eventOperationType == 'Underplay clip' || scope.row.segmentId == 4 || scope.row.segmentId == 5 || scope.row.segmentId == 10" :SelectType="1" :SelectValue="{
              fileId: scope.row.fileId,
              fileName: scope.row.fileName,
            }" @fileSelectChange="
              (pitchOnFile) => changeFile(pitchOnFile, scope.row,scope.$index)
            "></public-file-select>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.TimingIn')" width="150px">
        <template slot-scope="scope">
          <el-time-picker v-if="scope.row.segmentId != 0" v-model="scope.row.timingInTime" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm:ss" :clearable="false" @blur="calculateTime(scope.row, scope.$index, 'start')">
          </el-time-picker>
        </template>
      </el-table-column>
      <!-- <el-table-column label="帧">
                <template slot-scope="scope">
                    <el-input
                    v-if="scope.row.segmentId == 1 || scope.row.segmentId == 2"></el-input>
                </template>
            </el-table-column> -->
      <el-table-column :label="$t('lang.TimingOut')" width="150px">
        <template slot-scope="scope">
          <el-time-picker v-if="scope.row.segmentId != 0" v-model="scope.row.timingOutTime" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm:ss" :clearable="false" @blur="calculateTime(scope.row, scope.$index, 'stop')">>
          </el-time-picker>
        </template>
      </el-table-column>
      <!-- <el-table-column label="帧">
                <template slot-scope="scope">
                    <el-input
                    v-if="scope.row.segmentId == 1 || scope.row.segmentId == 2"></el-input>
                </template>
            </el-table-column> -->
      <el-table-column :label="$t('lang.AccumulatedTimeing')" width="220px">
        <template slot-scope="scope">
          <span v-if="scope.row.segmentId != 0">{{ scope.row.accumulatedProgramTiming == 0? '00:00:00' : scope.row.accumulatedProgramTiming * 1000 | DURATION }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.operation')" width="150px">
        <template slot-scope="scope">
          <span title="insert row down" v-if="scope.row.segmentId != 7" class="iconfont i-insert" @click="addRow(scope.$index)"><img src="@/assets/img/insert.png"></span>
          <span :class="{'leftM': scope.row.segmentId == 7}" class="iconfont i-delete" @click="deleteRow(scope.row, scope.$index)"></span>
        </template>
      </el-table-column>
    </el-table>
    <div class="add-icon" v-if="tableData.length == 0">
      <i class="iconfont i-add" @click="addRow(tableData.length - 1)"></i>
    </div>
    <div class="footer">
      <el-button class="delete black" @click="deleteTem" v-if="operateType == 'edit'">
        {{ $t('lang.delete') }}
      </el-button>
      <el-button class="cancel" @click="cancel">
        {{ $t('lang.cancel') }}
      </el-button>
      <el-button v-if="operateType == 'edit'" class="save" type="primary" @click="saveTem('new')">
        {{ $t('lang.saveAs') }}
      </el-button>
      <el-button class="save" type="primary" @click="saveTem">
        {{ $t('lang.save') }}
      </el-button>
    </div>
  </el-form>
</template>
<script>
import selectMenu from '@/components/common/selectMenu'
// import SelectSearchR from '@/components/common/SelectSearchR';
import Bus from '@/assets/js/vueBus.js'
import { Segments, LogoConfig, ScteType, UnderplayType } from '@/assets/js/temConfig.js'
import { mapState } from 'vuex'
import PublicFileSelect from '@/components/common/PublicFileSelect.vue'
import Outil from '@/assets/js/utils.js'
import uploadFile from './uploadFile.vue'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {
          tag: 'tem',
          operate: 'add'
        }
      }
    }
  },
  components: {
    selectMenu,
    // SelectSearchR,
    PublicFileSelect,
    uploadFile
  },
  data () {
    return {
      // Source查询列表
      SourceList: [],
      // Source查询分页
      SourcePaging: {
        SourcepageNum: 0,
        loadEnd: false
      },
      // source滚动加载
      SourcebindScroll: {
        onScroll: this.getSourceList,
        directive: '.el-scrollbar__wrap .el-scrollbar__view',
        distance: 50
      },
      // 拥有者session
      userSessionId: '',
      operateType: 'add', // 区分新增或编辑
      operateId: '', // 编辑数据template的id
      oldEventSegments: [], // 更新时做数据对比
      programDuration: 30,
      scteTimes: 0,
      startTime: '',
      overTimeFlag: false,
      receiverId: '',
      nowDate: new Date(),
      form: { // 界面数据
        templateName: '',
        episode: 1,
        houseId: '',
        sourceType: 0,
        referenceMediaId: '',
        referenceMediaName: '',
        mediaTotalTime: 0, // 对应TRT
        templateVideoTotalTime: 0,
        scteTotalTime: 0,
        blackTime: 0,
        addEventSegments: [],
        updateEventSegments: [],
        deleteEventSegments: [],
        timingId: '',
        scteSpliceDurationDefault: 90,
        overUnderTime: 30 * 60,
        description: ''
      },
      config: { // 初始配置文件，TODO:改为从initConfig中获取
        segments: Segments,
        logoConfig: LogoConfig,
        scteType: ScteType,
        underplayType: UnderplayType
      },
      fileData: [], // 记录file文件
      region: '',
      tableData: [ // 记录event数据
        {
          segmentId: 0,
          eventOperationType: '',
          timingInTime: '00:00:00',
          timingIn: 0,
          timingOutTime: '00:00:00',
          timingOut: 0,
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 0
        }
      ],
      bindScroll: {
        loading: false,
        noMore: false,
        onScroll: this.getNextPage,
        directive: '.el-select-dropdown__list'
      },
      McpObj: { // 文件滚动加载
        pageNum: 1,
        pageSize: 10,
        condition: ''
      },
      loading: false,
      mcpTimingList: [],
      scteDefaultList: [
        {
          label: '30 seconds',
          value: 30
        }, {
          label: '60 seconds',
          value: 60
        }, {
          label: '90 seconds',
          value: 90
        }, {
          label: '120 seconds',
          value: 120
        }
      ],
      TimingUpload: {
        icon: true,
        multiple: false,
        fileType: '.csv,.xml',
        folderName: '/Playout/Timing',
        type: 3
      },
      rPar: {
        // 获取R列表的参数
        condition: '',
        tpeerId: '',
        bookmardIds: 'all',
        unClassified: true,
        pageNum: 1,
        pageSize: 35
      },
      pickerDateBeg: {
        disabledDate (time) {
          return time.getTime() < new Date().getTime()
        }
      }
    }
  },
  computed: mapState({
    State: (state) => state
  }),
  watch: {
    info (val) {
      this.initFormData(val)
    },
    'form.templateName': {
      handler (val) {
        this.changeHouseId()
      }
    }
  },
  created () {
    Bus.$on('refreshFileList', () => {
      this.getMcpList()
    })
    this.initFormData(this.info)
    this.region = this.$store.state.region ? this.$store.state.region : this.State.common.baseUrl.awsRegionalInfo.region
    this.getMcpList()
    // 获取source列表
    this.getSourceList()

    const ProgramRMessage = Outil.getProgramReceiver()
    if (ProgramRMessage) {
      this.currentSelectData(ProgramRMessage)
    } else {
      this.$router.push({
        path: '/wb'
      })
    }
  },
  methods: {
    deleteTiming (item) {
      const Url = '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/delete'
      const params = {
        fileId: item.id
      }
      this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message.success('delete success')
          this.getMcpList()
        } else {
          this.$message.info(this.$t('lang.fileUsed'))
        }
      }).catch()
    },
    currentSelectData (item, index) {
      // 接收R数据
      // this.chooseRIndex = index;
      this.receiverId = JSON.parse(JSON.stringify(item)).peerId
    },
    editTem () {
      this.sortSegments()
      const params = this.objDeepCopy(this.form)
      params.id = this.operateId
      if (params.overUnderTime) {
        // true是超出false没超出
        if (!this.overTimeFlag) {
          params.overUnderTime = -params.overUnderTime
          params.templateVideoTotalTime = this.programDuration * 60
        }
      }
      this.$confirm(this.$t('lang.UpdateTemplate'), '', {
        confirmButtonText: this.$t('lang.confirm'),
        cancelButtonText: this.$t('lang.close'),
        type: ''
      }).then(() => {
        this.axios.post('/gatewayPlayoutUrl/tvu-playout/eventTemplate/update', params).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.updateSuccess'))
            Bus.$emit('refreshTemList', 'tem')
            this.$emit('closeProgramTemplate')
            this.InformEventUpdate()
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch()
      }).catch()
    },
    addTem () {
      const params = this.objDeepCopy(this.form)
      params.addEventSegments = this.objDeepCopy(this.tableData)
      if (params.overUnderTime) {
        // true是超出false没超出
        if (!this.overTimeFlag) {
          params.overUnderTime = -params.overUnderTime
          params.templateVideoTotalTime = this.programDuration * 60
        }
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/eventTemplate/add', params).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.operateType = 'edit'
          this.operateId = res.data.result.id
          this.form.addEventSegments = []
          this.form.updateEventSegments = []
          this.form.deleteEventSegments = []
          this.getTemInfoById(this.operateId, 'tem')
          this.$message.success(this.$t('lang.addSuccess'))
          Bus.$emit('refreshTemList', 'tem')
          this.$emit('closeProgramTemplate')
          this.InformEventUpdate()
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    },
    // 新增template
    saveTem (tag) {
      // 保存时form表单空验证
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // 当用户选择了Air Date and Time之后需要获取R相关信息并添加参数传给后台
          if (this.startTime != '' && this.startTime != null) {
            this.form.receiverId = this.receiverId
            this.form.startTime = this.startTime
          } else {
            // 清空时间时，会不清除历史的时间
            this.form.startTime = 0
          }
          if (this.form.templateName.indexOf('/') >= 0) {
            this.$message.error(`/ ${this.$t('lang.notAllowedName')}`)
            return
          }
          // 通过判断有没有开始时间来更新event
          if (this.operateType == 'add' || this.operateType == 'edit' && tag && tag == 'new') {
            this.addTem()
          } else {
            this.editTem()
          }
        } else {
          return false
        }
      })
    },
    // 通知event更新
    InformEventUpdate () {
      // 通过websocket通知更新event
      this.$BehaviorSyns.SendBehavior('EventListChange', 1)
    },
    // 删除template
    deleteTem () {
      this.$confirm(this.$t('lang.deleteMediaList'), '', {
        confirmButtonText: this.$t('lang.Ok'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const Url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/delete'
        const params = {
          ids: [this.operateId]
        }
        this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message.success(this.$t('lang.deleteSuccess'))
            // Bus.$emit('goTemplateBlank', {
            //   type: 'add',
            //   tag: 'tem'
            // }, false)
            this.$emit('closeProgramTemplate')
            Bus.$emit('refreshTemList', 'tem')
          } else {
            this.$message.info(this.$t('lang.fileUsed'))
          }
        })
      }).catch()
    },
    // 根据templateId拿template信息/根据fileId拿event信息
    getTemInfoById (id, tag) {
      if (this.loading) {
        this.$message.info(this.$t('lang.frequentOperation'))
        return
      }
      this.loading = true
      this.tableData = []
      const params = tag && tag == 'tem' ? { id } : {
        fileId: id,
        defaultScteDuration: this.form.scteSpliceDurationDefault
      }
      const url = tag && tag == 'tem' ? '/gatewayPlayoutUrl/tvu-playout/eventTemplate/getById' : '/gatewayPlayoutUrl/tvu-playout/eventTemplate/resolveSegments'
      this.axios.post(url, params, {
        contentType: 'application/json;charset=UTF-8'
      }).then((res) => {
        this.loading = false
        if (res.data.errorCode == '0x0') {
          const data = res.data.result
          let eventArr = []
          if (tag && tag == 'tem') {
            this.form.templateName = data.templateName
            this.form.episode = data.episode
            this.form.houseId = data.houseId
            this.form.sourceType = data.sourceType
            this.form.referenceMediaId = data.referenceMediaId
            this.form.referenceMediaName = data.referenceMediaName
            this.form.mediaTotalTime = data.mediaTotalTime
            this.form.templateVideoTotalTime = data.templateVideoTotalTime
            this.form.blackTime = data.blackTime
            this.form.scteSpliceDurationDefault = data.scteSpliceDurationDefault == '0' ? '90' : data.scteSpliceDurationDefault
            this.form.overUnderTime = data.overUnderTime
            this.scteTimes = data.breaks
            this.form.scteTotalTime = data.breakTotalTime
            this.startTime = data.startTime == 0 ? '' : data.startTime
            this.oldEventSegments = tag && tag == 'tem' && data.eventSegments ? this.objDeepCopy(data.eventSegments) : [] // 只有选中template时才记录初始的event
            if (data.overUnderTime >= 0) {
              this.programDuration = Math.floor((data.templateVideoTotalTime - data.overUnderTime) / 60)
            } else {
              this.programDuration = Math.floor((data.templateVideoTotalTime) / 60)
            }
          } else {
            // 选择timing文件匹配到视频
            this.MatchFile(res.data.result)
          }
          this.form.description = data.description || ''
          // if (tag && tag == 'mcp') {
          eventArr = data.eventSegments ? this.objDeepCopy(data.eventSegments) : []
          // }
          if (eventArr.length > 0) {
            // if (row.segmentId == 1 && tag == 'start') {
            //     const referenceMediaBefore = (this.tableData.slice(0, rowIndex + 1)).filter(item => item.segmentId == 1)
            //     itemObj.black = itemObj.timingIn - referenceMediaBefore[referenceMediaBefore.length - 2].timingOut
            // }
            eventArr.forEach((itm) => {
              if (itm.segmentId == '2' && !itm.eventOperationType) itm.eventOperationType = 'SCTE only'
            })
            this.tableData = this.objDeepCopy(eventArr)
            this.changeTableData()
          } else {
            this.addRow(this.tableData.length - 1)
          }
          this.TimeRemaining(this.form.mediaTotalTime)
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    },
    changeTimingFile (id) {
      this.getTemInfoById(id, 'mcp')
    },
    // 切换文件
    changeFile (pitchOnFile, row, rowIndex) {
      const itemObj = this.tableData[rowIndex]
      pitchOnFile.videoTimes = Math.floor(pitchOnFile.videoTimes)
      itemObj.timingIn = 0
      itemObj.duration = pitchOnFile.videoTimes
      if (itemObj.segmentId == 2 && pitchOnFile.videoTimes > this.form.scteSpliceDurationDefault) {
        itemObj.duration = this.form.scteSpliceDurationDefault
      }
      itemObj.timingOut = itemObj.duration
      itemObj.fileId = pitchOnFile.id
      this.tableData.splice(rowIndex, 1, itemObj)
      this.changeTableData()
    },
    changeHouseId () {
      if (this.startTime != '' && this.startTime != null && this.form.referenceMediaId != '') {
        if (this.form.templateName != '') {
          const setTime = Outil.getDateTime(new Date(this.startTime))
          this.form.houseId = `${this.form.templateName.substring(0, 4)}-${setTime.month}${setTime.day}${setTime.year}-${setTime.hour}${setTime.min}${setTime.s}`
        } else {
          this.form.houseId = ''
        }
      } else {
        this.form.houseId = ''
      }
    },
    MatchFile (fileMessage) {
      if (fileMessage.referenceMediaId) {
        const item = {
          id: fileMessage.referenceMediaId,
          name: fileMessage.referenceMediaName,
          videoTimes: fileMessage.mediaTotalTime
        }
        this.changeReferenceFile(item)
      }
    },
    // 更改类型
    sourceTypeChange () {
      this.form.referenceMediaId = ''
      this.form.referenceMediaName = ''
    },
    // 更改主视频
    changeReferenceFile (item) {
      this.form.referenceMediaId = item.id
      this.form.referenceMediaName = item.name
      // this.form.templateName = this.form.templateName == ''? item.name :  this.form.referenceMediaName.split('.mp4')[0]
      this.form.mediaTotalTime = Math.floor(item.videoTimes ? item.videoTimes : 0)
      this.form.templateName = this.form.templateName == '' ? this.form.referenceMediaName.split('.mp4')[0] : this.form.templateName
      this.changeHouseId()
      this.TimeRemaining(this.form.mediaTotalTime)
    },
    // 选择source
    SelectSource (peerId) {
      const FileMessage = this.SourceList.filter((item) => item.peerId === peerId)
      this.form.referenceMediaId = FileMessage[0].peerId
      this.form.referenceMediaName = FileMessage[0].name
      this.form.mediaTotalTime = this.programDuration * 60
      // this.form.templateName = this.form.templateName == '' ? this.form.referenceMediaName : this.form.templateName
      this.changeHouseId()
      this.TimeRemaining(this.form.mediaTotalTime)
    },
    // 判断视频是否又剩余时间
    TimeRemaining (mediaTotalTime) {
      const DataIndex = this.tableData.length
      const Penult = this.tableData[DataIndex - 2]
      if (!Penult) {
        return
      }
      // 判断倒数第二个是否为Reference media
      if (Penult.segmentId == 1) {
        if (mediaTotalTime > Penult.timingIn) {
          Penult.timingOut = mediaTotalTime
          this.tableData.splice(DataIndex - 2, 1, Penult)
          this.changeTableData()
        }
      } else {
        const referenceMediaArr = this.tableData.filter((item) => item.segmentId == 1)
        const LastTimingOut = referenceMediaArr.length > 0 ? referenceMediaArr[referenceMediaArr.length - 1].timingOut : 0
        if (mediaTotalTime > LastTimingOut) {
          const obj = {
            segmentId: 1,
            eventOperationType: '',
            fileId: '',
            timingIn: LastTimingOut,
            timingInTime: '00:00:00',
            timingOut: mediaTotalTime,
            timingOutTime: '00:00:00',
            accumulatedProgramTiming: 0,
            suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
            duration: 0,
            black: 0,
            segmentOrder: DataIndex - 1
          }
          this.tableData.splice(DataIndex - 1, 0, obj)
          this.changeTableData()
        }
      }
    },
    // 更新template提交之前数据处理
    sortSegments () {
      const newArr = [...new Set([...this.oldEventSegments, ...this.tableData])]
      const arr1 = this.objDeepCopy(this.tableData)
      const arr2 = this.objDeepCopy(this.oldEventSegments)
      const deleteEventSegments = [...newArr].filter((x) => [...arr1].every((y) => y.id !== x.id))
      const addEventSegments = [...newArr].filter((x) => [...arr2].every((y) => y.id !== x.id))
      const updateEventSegments = arr1.filter((x) => arr2.filter((y) => y.id == x.id))
      this.form.updateEventSegments = []
      updateEventSegments.forEach((item) => {
        if (item.id) {
          this.form.updateEventSegments.push(item)
        }
      })
      this.form.deleteEventSegments = []
      deleteEventSegments.forEach((item) => {
        this.form.deleteEventSegments.push(item.id)
      })
      this.form.addEventSegments = []
      addEventSegments.forEach((item) => {
        if (item.segmentId && item.segmentId != null) {
          this.form.addEventSegments.push(item)
        }
      })
    },
    calculateTime (row, rowIndex, tag) {
      /** 修改时间时，如果开始和结束时间都有，
       * 如果修改开始时间，结束时间小于当前时间时自动修改为开始时间往后添加10s
       * 如果修改结束时间，开始时间大于当前时间时自动修改为结束时间往前减少10s，最小为00:00:00
       * 每次修改时同步修改duration，后面可以直接判断duration
       *
       * 如果修改的是Reference Meida的开始和结束时间，则需要同步修改前后Reference Media的时间，这里同步修改blackTime
       * 所有修改必须保证每一条数据开始和结束时间准确（Reference Meida）
      */
      console.log(row, rowIndex, tag)
      const itemObj = this.tableData[rowIndex]
      itemObj.timingIn = this.$options.filters.GETDURATIONNUM('', `2021-1-1 ${row.timingInTime}`)
      itemObj.timingOut = this.$options.filters.GETDURATIONNUM('', `2021-1-1 ${row.timingOutTime}`)
      itemObj.duration = itemObj.timingOut - itemObj.timingIn
      if (tag == 'start') {
        if (itemObj.duration < 0) {
          itemObj.timingOut = itemObj.timingIn
        }
        // program Start 自动计算结束时间
        if (rowIndex > 0 && this.tableData[rowIndex - 1].segmentId == 6) {
          const startObj = this.tableData[rowIndex - 1]
          startObj.timingOut = itemObj.timingIn
          startObj.duration = startObj.timingOut - startObj.timingIn
          this.tableData.splice(rowIndex - 1, 1, startObj)
        }
      } else if (itemObj.timingIn > itemObj.timingOut) {
        itemObj.timingIn = itemObj.timingOut
      }
      if (row.segmentId == 1 && tag == 'start') {
        const referenceMediaBefore = (this.tableData.slice(0, rowIndex + 1)).filter((item) => item.segmentId == 1)
        itemObj.black = itemObj.timingIn - referenceMediaBefore[referenceMediaBefore.length - 2].timingOut
      }
      this.tableData.splice(rowIndex, 1, itemObj)
      this.changeTableData()
    },
    async queryParentId () {
      const param = {
        userId: localStorage.getItem('userId'),
        programId: this.$BehaviorSyns.getProgramId()
      }
      await this.axios
        .post('/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/queryParentId', param)
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.userSessionId = res.data.result.session
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch()
    },
    async getMcpList () {
      const params = {
        isDirectory: false,
        region: this.region,
        service: 'pp',
        type: 3,
        directoryName: 'Playout/Timing',
        nameLike: this.McpObj.condition,
        pageIndex: this.McpObj.pageNum,
        pageSize: this.McpObj.pageSize
      }
      await this.queryParentId()
      this.axios.post('/file/query-user-files', params, { requestBase: 'GATEWAY', sessionRoleId: this.userSessionId }).then((res) => {
        if (res.data.errorCode === '0x0') {
          if (params.pageIndex >= res.data.result.pages) {
            this.bindScroll.noMore = true
          }
          if (params.pageIndex > 1) {
            this.mcpTimingList = this.mcpTimingList.concat(res.data.result.records)
          } else {
            this.mcpTimingList = res.data.result.records
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    },
    // 搜索timming文件列表
    searchFile (value) {
      this.McpObj.pageNum = 0
      this.McpObj.condition = value
      this.getMcpList()
    },
    // 删除行
    deleteRow (row, index) {
      this.tableData.splice(index, 1)
      this.changeTableData()
    },
    // 新增行
    addRow (index) {
      const obj = {
        segmentId: null,
        eventOperationType: '',
        fileId: '',
        timingIn: 0,
        timingInTime: '00:00:00',
        timingOut: 0,
        timingOutTime: '00:00:00',
        accumulatedProgramTiming: 0,
        suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
        duration: 0,
        black: 0,
        segmentOrder: index + 1
      }
      this.tableData.splice(index + 1, 0, obj)
    },
    changeScteEvent (obj) {
      const itemObj = this.tableData[obj.index]
      itemObj.eventOperationType = obj.val
      itemObj.timingIn = 0
      itemObj.timingOut = this.form.scteSpliceDurationDefault
      this.tableData.splice(obj.index, 1, itemObj)
      this.changeTableData()
    },
    changeSegment (obj) {
      const itemObj = this.tableData[obj.index]
      itemObj.segmentId = obj.val
      itemObj.eventOperationType = ''
      // 如果是ReferenceMedia，In应该默认为上一次主视频结束时间，Out为视频总时长
      // 如果是SCTE类型，duration为统一设置的默认值
      if (obj.val == 1) {
        const referenceMediaArr = this.tableData.filter((item) => item.segmentId == 1)
        itemObj.timingIn = referenceMediaArr.length > 1 ? referenceMediaArr[referenceMediaArr.length - 2].timingOut : 0
        itemObj.timingOut = this.form.mediaTotalTime
      } else if (obj.val == 2) {
        itemObj.timingIn = 0
        itemObj.timingOut = this.form.scteSpliceDurationDefault
        itemObj.eventOperationType = 'SCTE only'
      } else {
        itemObj.timingIn = 0
        itemObj.timingOut = 0
      }
      if (obj.val == 3) itemObj.eventOperationType = 'Logo on'
      this.tableData.splice(obj.index, 1, itemObj)
      this.changeTableData()
    },
    // 模板Duration变化监听
    DurationChange () {
      // 类型为Live时
      if (this.form.sourceType) {
        this.form.mediaTotalTime = this.programDuration * 60
        this.TimeRemaining(this.form.mediaTotalTime)
      }
      this.changeTableData()
    },
    changeTableData (scteSuration) {
      let totalDuration = 0
      this.scteTimes = 0
      this.form.scteTotalTime = 0
      this.form.blackTime = 0
      const indexArr = []
      this.tableData.forEach((item, i) => {
        if (item.segmentId == 1) indexArr.push(i)
      })
      let SerialNumber = 0
      this.tableData.forEach((itm, index) => {
        // Reference Media需要计算blackTime
        // if (itm.segmentId == 1) {
        //     if (index != 0 && index != indexArr[0]) {
        //         let i = indexArr.findIndex(m => m == index)
        //         if (!itm.black || itm.black == undefined) {
        //             itm.black = itm.timingIn - this.tableData[indexArr[i - 1]].timingOut
        //         } else {
        //             itm.timingIn = this.tableData[indexArr[i - 1]].timingOut + itm.black
        //         }
        //     }
        //     if (itm.black) this.form.blackTime += itm.black
        // }
        // 计算序号
        if (itm.segmentId == 1) {
          SerialNumber++
          itm.SerialNumber = SerialNumber
        }
        // 如果是SCTE Program End则开始和结束时间都等于上一条数据的timeOut
        // 需要传给后台的排序
        itm.segmentOrder = index
        if (itm.segmentId == 7 && index != 0) {
          itm.timingIn = this.tableData[index - 1].accumulatedProgramTiming
          itm.timingOut = this.tableData[index - 1].accumulatedProgramTiming
        }
        // 切换SCTE duration时直接修改列表中SCTE的timeOut
        if (scteSuration && itm.segmentId == 2) {
          itm.timingOut = itm.timingIn + scteSuration
        }
        itm.timingInTime = itm.timingIn == 0 ? '00:00:00' : `${this.$options.filters.DURATION(itm.timingIn * 1000)}`
        itm.timingOutTime = itm.timingOut == 0 ? '00:00:00' : `${this.$options.filters.DURATION(itm.timingOut * 1000)}`
        itm.duration = itm.timingOut - itm.timingIn
        // if (itm.segmentId == 1 && itm.black) {
        //     itm.accumulatedProgramTiming = index == 0? itm.duration : this.tableData[index - 1].accumulatedProgramTiming + itm.duration + itm.black
        //     totalDuration += (itm.duration + itm.black)
        // } else {
        itm.accumulatedProgramTiming = index == 0 ? itm.duration : this.tableData[index - 1].accumulatedProgramTiming + itm.duration
        totalDuration += itm.duration
        // }
        if (itm.segmentId == 2) {
          this.scteTimes += 1
          this.form.scteTotalTime += itm.duration
        }
        if (itm.segmentId == 9) {
          this.form.blackTime += itm.duration
        }
      })
      this.form.templateVideoTotalTime = totalDuration
      if (this.programDuration * 60 >= this.form.templateVideoTotalTime) {
        this.overTimeFlag = false
        this.form.overUnderTime = this.programDuration * 60 - this.form.templateVideoTotalTime
      } else {
        this.overTimeFlag = true
        this.form.overUnderTime = this.form.templateVideoTotalTime - this.programDuration * 60
      }
    },
    initFormData (obj) {
      if (obj.type != '') {
        this.operateType = obj.type
      }
      if (obj.type == 'add') {
        this.operateId = ''
        this.form = {
          templateName: '',
          episode: 1,
          houseId: '',
          sourceType: 0,
          referenceMediaId: '',
          referenceMediaName: '',
          mediaTotalTime: 0, // 对应TRT
          templateVideoTotalTime: 0,
          blackTime: 0,
          addEventSegments: [],
          updateEventSegments: [],
          deleteEventSegments: [],
          timingId: '',
          scteSpliceDurationDefault: 90,
          scteTotalTime: 0,
          overUnderTime: 30 * 60,
          description: ''
        }
        this.tableData = [{
          segmentId: 6,
          eventOperationType: '',
          timingIn: 0,
          timingInTime: '00:00:00',
          timingOut: 1,
          timingOutTime: '00:00:01',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 0
        },
        {
          segmentId: 1,
          eventOperationType: '',
          timingIn: 1,
          timingInTime: '00:00:01',
          timingOut: 2,
          timingOutTime: '00:00:02',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 1
        },
        {
          segmentId: 7,
          eventOperationType: '',
          timingIn: 2,
          timingInTime: '00:00:02',
          timingOut: 2,
          timingOutTime: '00:00:02',
          accumulatedProgramTiming: 0,
          suspend: 0, // 0表示暂停，1表示不暂停，默认暂停
          duration: 0,
          fileId: '',
          black: 0,
          segmentOrder: 2
        }]
        this.changeTableData()
      } else {
        if (obj.tag == 'tem') {
          this.operateId = obj.data.id
          this.form.timingId = ''
          this.programDuration = 30
        }
        this.getTemInfoById(obj.data.id, obj.tag)
      }
    },
    getNextPage () {
      if (this.bindScroll.loading || this.bindScroll.noMore) return
      this.McpObj.pageNum += 1
      this.getMcpList()
    },
    cancel () {
      // Bus.$emit('goTemplateBlank', {
      //   type: 'add',
      //   tag: 'tem'
      // }, false)
      this.$emit('closeProgramTemplate')
    },
    objDeepCopy (source) {
      var sourceCopy = source instanceof Array ? [] : {}
      for (var item in source) {
        sourceCopy[item] = typeof source[item] === 'object' && source[item] != null ? this.objDeepCopy(source[item]) : source[item]
      }
      return sourceCopy
    },
    // 获取source列表
    getSourceList (value) {
      this.SourcePaging.SourcepageNum++
      const param = {
        bookmardIds: 'all',
        unClassified: true,
        pack: true,
        anywhere: true,
        gridPack: true,
        gridSdi: true,
        ext: true,
        token: true,
        scte: true,
        pageNum: this.SourcePaging.SourcepageNum,
        pageSize: 35,
        condition: ''
      }
      if (value) {
        this.SourcePaging.SourcepageNum = 1
        param.condition = value
        param.pageNum = this.SourcePaging.SourcepageNum
        this.SourcePaging.loadEnd = false
      }
      if (!this.SourcePaging.loadEnd) {
        this.axios.post(Outil.getUrl(`/event/listSource/${this.$BehaviorSyns.getProgramId()}`), param)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.errorCode == '0x0') {
                const { result } = res.data
                if (result.deviceList.result) {
                  if (param.pageNum == 1) {
                    this.SourceList = result.deviceList.result.list
                  } else {
                    this.SourceList.push(...result.deviceList.result.list)
                  }
                }
                if (result.deviceList.result.list.length < 35) {
                  this.SourcePaging.loadEnd = true
                }
              } else {
                const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
                this.$message.info(errorInfo)
              }
            }
          }).catch()
      }
    }
  },
  beforeDestroy () {
    Bus.$off('refreshFileList')
  }
}
</script>
<style lang="less" scoped>
.template-box {
  width: 90%;
  padding: 40px 20px 10px;
  margin: 0 auto;
  height: calc(100% - 65px);
  overflow-y: auto;
  .el-form-item {
    margin: 0 0 10px;
    /deep/ .el-form-item__content {
      text-align: left;
      min-width: 250px;
      .el-form-item__error {
        padding-top: 0;
        line-height: 6px;
      }
      .el-input-group--append {
        input {
          border-right: none;
        }
        .el-input-group__append {
          background: rgb(68, 68, 68);
          border: 1px solid #444;
          border-left: none;
        }
      }
      .el-textarea__inner {
        background: #444;
        border: 1px solid #444;
        color: #fff;
      }
    }
    &.timingFile {
      .el-form-item__content {
        position: relative;
        .timing-item {
          width: 90%;
          display: inline-block;
        }
      }
    }
    &.referenceFile,
    &.timingFile {
      /deep/.el-select {
        .el-select-dropdown {
          width: 100%;
        }
      }
    }
    ::v-deep.ReferenceMedia {
      display: flex;
      .MediaType {
        width: 60px;
      }
      .MediaSelect {
        width: 208px;
        margin-left: 5px;
      }
      .el-input--suffix {
        .el-input__suffix {
          width: 23px;
          right: 0px;
        }
        .el-input__inner {
          height: 34px;
          line-height: 34px;
          // font-size: 12px;
          color: #dbdbdb;
          padding-left: 8px;
          padding-right: 15px;
        }
      }
      .el-select-dropdown__item {
        font-size: 12px;
        padding-left: 10px;
      }
      .el-scrollbar__wrap {
        text-align: left;
        max-width: 240px;
        .el-scrollbar__view {
          width: 100%;
        }
      }
    }
  }
  /deep/ .el-select {
    width: 100%;
    .el-select-dropdown__item {
      padding: 0 12px 0 20px;
      .deltete-icon {
        display: none;
      }
      &.hover {
        .deltete-icon {
          display: inline-block;
        }
      }
    }
  }
  /deep/ .el-table {
    table {
      min-height: 50px;
    }
    .el-table__row {
      td {
        z-index: 1;
      }
      th .cell {
        height: 40px;
        line-height: 40px;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 100%;
      }
      .leftM {
        margin-left: 20px;
      }
    }
  }
  /deep/ .el-input {
    .el-input__inner {
      height: 34px;
      line-height: 34px;
      border: 1px solid #444;
      background: rgb(68, 68, 68);
    }
  }
  /deep/ .el-scrollbar__wrap {
    height: 214px !important;

    .el-scrollbar__view {
      height: 210px !important;
      width: 100%;
      overflow-y: auto;

      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        background-color: rgba(144, 147, 153, 0.2);
        opacity: 0.7;
      }

      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        border-radius: 10px;
        background: none;
      }
    }
  }
  .line {
    clear: both;
    background-color: #444;
    height: 4px;
  }
  .calculate-info {
    // width: 80%;
    margin: 0 auto;
    /deep/ .el-form-item {
      height: 30px;
      .el-form-item__label,
      .el-form-item__content {
        height: 30px;
        line-height: 30px;
      }
    }
  }
  .add-icon {
    float: right;
    .i-add:before {
      font-size: 20px;
    }
    &.notAllowed {
      .i-add:before {
        cursor: not-allowed;
      }
    }
  }
  .footer {
    height: 60px;
    line-height: 60px;
    width: 100%;
    text-align: right;
    padding-right: 40px;
    position: absolute;
    bottom: 0;
    right: 0;
    background: #252525;
    border-top: 1px solid #000;
    .el-button {
      padding: 7px 20px;
      &.black {
        margin-right: 50px;
        border: 1px solid #524c4c;
      }
    }
  }
  .notAllowed {
    cursor: not-allowed !important;
    &:hover {
      color: #fff;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
